
import { useState, useRef } from "react";
import Config from "../Config";
import InputComboGrupaE from "./InputComboGrupaE";
import InputTextAlpha from "./InputTextAlpha";





function InputParentsMultiE(props)
{

    const [filterParam, setFilterParam] = useState({
        imie: props.mainView.readFilter('imie',''), 
        nazwisko:  props.mainView.readFilter('nazwisko',''),  
        p_grupa_id: props.mainView.readFilter('p_grupa_id','_x_'), 

        zawiera_stawke: '',
        niezawiera_stawki: '',

        stan_umowy: '1',
    });


    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    var clFlag = 1;
    if(props.clearFlag != null && props.clFlag != undefined) clFlag = props.clFlag;
    var [clearFlag, setClearFlag] = useState(clFlag);


    var max = 1000;
    if(props.max != undefined && props.max != null) max = props.max;

    const [maxKids,setMaxKids] = useState(max);

    const [tabSelected, setTabSelected] = useState([
       
    ]);


    const [view, setView] = useState('btn');


    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
     

        fetch( Config.url + '/rest_v1_employessModule,kids', {
            method: 'POST', 
            body: '', 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {                                              
                        setTab(res.result);                                         
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }


    const changeView = () => {
        if(view == 'btn') {setView("dlg"); }  else setView('btn'); 
    } 


    const saveData = () => {


        var selected = new Array();

        var selectedCallback = new Array();

        for(var g=0; g < tab.length; g++)
            {                
                    for(var d=0; d < tab[g].dzieci.length; d++)
                        {
                                
                              if(tab[g].dzieci[d].param1 == '1')  {  

                                selected.push( tab[g].dzieci[d]);
                          
                                    for(var r=0; r < tab[g].dzieci[d].rodzice.length; r++   )
                                    {
                                        

                                        selectedCallback.push( {
                                            px_group_id: tab[g].dzieci[d].rodzice[r].id,
                                            imie: tab[g].dzieci[d].rodzice[r].imie,
                                            nazwisko: tab[g].dzieci[d].rodzice[r].nazwisko,
                                            p_dziecko_id: tab[g].dzieci[d].id
                                          } );                                        
                                    }

                              };
                               
                        }   
                
            }

            setTabSelected(selected);
            changeView();

            if(props.onParentsSelected != undefined) props.onParentsSelected(selectedCallback);

    }


    const goSelect = (e) => {

        var p_grupa_id = e.currentTarget.getAttribute('p_grupa_id');
        var p_dziecko_id = e.currentTarget.getAttribute('p_dziecko_id');

        console.log(p_grupa_id, p_dziecko_id);

        for(var g=0; g < tab.length; g++)
        {
            if(tab[g].id == p_grupa_id )
            {
                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                            if(tab[g].dzieci[d].id == p_dziecko_id )
                            {
                                if(tab[g].dzieci[d].param1 == '0')  {  tab[g].dzieci[d].param1 = '1' } else tab[g].dzieci[d].param1 = '0' ;
                            }else
                            {
                                if(maxKids == 1)    tab[g].dzieci[d].param1 = '0' ;
                            }
                    }   
            }else 
            if(maxKids == 1) {

                for(var d=0; d < tab[g].dzieci.length; d++)
                    {
                         tab[g].dzieci[d].param1 = '0' ;
                    } 
            }


        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));

    }


    const selectAll = (e) =>  {


        if(maxKids == 1) return;

        var p_grupa_id = e.target.getAttribute('id');
        var txt        = e.target.innerHTML;

     
        if(txt == 'zaznacz')
        {
            e.target.innerHTML = 'odznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                    
                                         tab[g].dzieci[d].param1 = '1';
                                   
                            }   
                    }
                }

        }else
        {
            e.target.innerHTML = 'zaznacz';

            for(var g=0; g < tab.length; g++)
                {
                    if(tab[g].id == p_grupa_id )
                    {
                        for(var d=0; d < tab[g].dzieci.length; d++)
                            {
                                    
                                tab[g].dzieci[d].param1 = '0';
                                
                            }   
                    }
                }
        }

        var s = JSON.stringify(tab);
        setTab(JSON.parse(s));
        
    }


    
 


    const valChangeListener = (filedName, val, correct, msg) => {

       //  console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );               
    }


    const goNextNew = () => {
        console.log("goNext");               
    }


    
    


    
    if(tab == null)
        {
            setTab([]);
            getTab();
        

            return <div>
                ...
            </div>
        }


        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);           
            setTabSelected([]);
        }


        if(props.clearFlag != null && props.clearFlag != undefined)
        {
            if(props.clearFlag != clearFlag)
            {
                setClearFlag(props.clearFlag);
                setTab(null);           
                setTabSelected([]);
            }
        }


        var dlg_view = null;

     if(view != 'btn') 
     {

        //-----------------------------------------------------------

        var rTab = new Array();

        console.log(tab);


        for(var k=0; k<tab.length; k++) //petla po grupach..
        {
         

            var nDz = new Array();

            for(var d = 0; d < tab[k].dzieci.length; d++  )
            {
                var goAdd0 = true;
                var goAdd1 = true;
                var goAdd2 = true;
                var goAdd3 = true;
                var goAdd4 = true;
                var goAdd5 = true;


                var dz = tab[k].dzieci[d];


                if(filterParam.p_grupa_id != "_x_")
                {
                    goAdd0 = false;

                    if(tab[k].id == filterParam.p_grupa_id) goAdd0 = true;
                }


                if(filterParam.imie.length > 2)
                {
                    goAdd1 = false;

                    if(  dz.imie.toLowerCase().includes( filterParam.imie.toLowerCase() )  )
                    {
                            goAdd1 = true;
                    }
                }

                if(filterParam.nazwisko.length > 2)
                {
                        goAdd2 = false;
    
                        if(  dz.nazwisko.toLowerCase().includes( filterParam.nazwisko.toLowerCase() )  )
                        {
                                goAdd2 = true;
                        }
    
                }

                if( goAdd0 && goAdd1 && goAdd2 && goAdd3 && goAdd4 && goAdd5)
                {
                    nDz.push( tab[k].dzieci[d] );
                }
            }


            if(nDz.length > 0)
            {
                var rRow        = new Array();
                rRow["id"]      = tab[k].id;
                rRow["nazwa"]   = tab[k].nazwa;
                rRow["dzieci"]  = nDz;
    
                rTab.push(rRow);
            }
                       

        }

        //-----------------------------------------------------------




        var dlg_view =  (

            <div className="dlg_window dlg_type_xxx shadowx">
    
                    <div className="dlg_title">
                         Wybierz dzieci - rodziców
                    </div>
    



                    <div className="table_filter">
                      

                            <div className="filter_controll">   
                                <label>Grupa: </label>                             
                                <InputComboGrupaE   userData={props.userData}  mainView={props.mainView}  value={filterParam.p_grupa_id}   valChange={valChangeListener} goNext={goNextNew} name="p_grupa_id" placeholder={"Archiwalne: "}   />
                            </div> 


                            <div className="filter_controll">   
                                        <label>Imię dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.imie}   valChange={valChangeListener} goNext={goNextNew} name="imie" placeholder={"Imię: "}   />
                           </div>  

                            <div className="filter_controll">   
                                        <label>Nazwisko dziecka: </label>                             
                                        <InputTextAlpha   userData={props.userData} value={filterParam.nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="nazwisko" placeholder={"Nazwisko: "}   />
                            </div> 

                            <br/>


                    </div>
    




                    <div className="dlg_content_x">
    
    
                                      <div className="xselect_multi xparents">
                                        {
                                            rTab.map( (gr, gi) => {
                                                return <div className="row_gr" >


                                                     {
                                                          maxKids != 1 &&
                                                         <strong>{gr.nazwa} <sup className="link_color"  id={gr.id} onClick={selectAll}>zaznacz</sup>   </strong>
                                                     }
                                                     
                                                     
                                                     <ul>
                                                            {
                                                                gr.dzieci.map( (dz, di) => {

                                                                   
                                                                        if(dz.rodzice.length == 0)
                                                                        {
                                                                            return null;
                                                                        }

                                                                        var css = '';

                                                                        if(dz.param1 == '1') css ="selected";

                                                                        return <li className={css}  p_grupa_id={gr.id} p_dziecko_id={dz.id} onClick={goSelect}>  
                                                                                    <div className="xselect_item" >

                                                                                    <div className="xselect_t_title" >{ dz.nazwisko + " " + dz.imie    } </div>
                                                                                    <div className="xselect_t_content" >
                                                                                    {
                                                                                            dz.rodzice.map( (rdz, inx) => {
                                                                                                return <div> {rdz.nazwisko + " " + rdz.imie} </div>
                                                                                            } )
                                                                                    }
                                                                                    </div>

                                                                                    </div>                                                                                                                                                     
                                                                                
                                                                            </li>
                                                                } ) 

                                                            }
                                                     </ul>
                                                     <br></br>
                                                    
                                                </div>
                                            } )
                                        }
                                        
                                      </div>  
    
                                        <div className="form_control">                                            
                                            <div className="btn" onClick={saveData}>zapisz</div>
                                            &nbsp; &nbsp;
                                            <div className="btn btn_back" onClick={changeView}>anuluj</div>
                                        </div>
    
                    </div>
    
                
            </div>
    );

    }
   
    
    var info = '';
    var ilosc = null;


    if(tabSelected.length == 0)
    {
        info = <div onClick={changeView} className="link_bad">Nie wybrano żadnego odbiorcy</div>; ;
    }else
    {
            ilosc = <div>
                <strong>wybranych: {tabSelected.length}</strong>
            </div>
    }
    
    return  <div>

                <br/>
                <div className="btn"    onClick={changeView} >wybierz odbiorców / lista rodziców</div> 

                <div className="xselect xparents">
                    {ilosc}
                    <br/>
                        {
                            tabSelected.map( (r, ix) => {
                                return <div className="xselect_item" onClick={changeView}>
                                           <div className="xselect_t_title">{r.nazwisko} {r.imie}  </div>
                                           <div className="xselect_t_content">
                                               {
                                                 r.rodzice.map(  (rr, ir) => {
                                                    return <div> {rr.imie + " " + rr.nazwisko}  </div>
                                                 } )
                                               }
                                           </div>
                                    </div>
                            } )
                        }

                        {info}

                        <br/>
                </div>


                {dlg_view} 
           </div>
}



export default InputParentsMultiE;